import React from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';
import Button from '../../components/Button';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Contact', to: '/contact/contact-ifys' },
  { label: 'Contact IFYS', to: '/contact/contact-ifys' },
  { label: 'Thank you' },
];

const ContactThankYouPage = () => {
  return (
    <PageLayout activeLink="contact">
      <PageHero
        title="Thank you"
        backgroundImage="/images/service-headers/contact%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 md:py-24 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6 tracking-tight">
            Thank you for your enquiry
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
            One of our friendly staff members will be in touch as soon as possible.
          </p>
          <Button href="/" variant="primary" size="md">
            Return to home
          </Button>
          <p className="mt-6 text-sm text-gray-600">
            Need to follow up? Call{' '}
            <a href="tel:+61754383000" className="text-ifys-blue font-semibold hover:underline">
              07 5438 3000
            </a>{' '}
            or email{' '}
            <a href="mailto:admin@ifys.com.au" className="text-ifys-blue font-semibold hover:underline">
              admin@ifys.com.au
            </a>.
          </p>
        </div>
      </section>
    </PageLayout>
  );
};

export default ContactThankYouPage;
